import React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

import { Hero } from "../components/hero"
import { PageBuilder } from "../components/pageBuilder"
import { toPlainText } from "../@utils/toPlainText"

const PageTemplate = ({ data: { page, contact, shopLink, alertBar }}) =>
    <Layout alertBar={alertBar}>
      <SEO
        title={(page.seo && page.seo.seo_title) ? page.seo.seo_title : page.title}
        description={(page.seo && page.seo.meta_description) ? page.seo.meta_description : page.hero && page.hero.content ? toPlainText(page.hero.content) : null}
        image={page?.heroImage?.image?.asset?.fixed?.src || null}
      />

      {page?.heroImage?.image &&
        <Hero
          image={page?.heroImage?.image?.asset?.fixed?.src || null}
          heading={page.hero ? page.hero.heading : page.title}
          content={page.hero ? page.hero.content : null}
          linkTo={page.hero ? page.hero.linkTo : null}
          links={page?.hero?.links}
          shopLink={shopLink.url}
        />
      }

      {page.content &&
        <PageBuilder
          content={page.content}
          contact={contact}
          shopLink={shopLink.url}
        />
      }

    </Layout>

export const query = graphql`
  query PageTemplateQuery($id: String!) {
    page: sanityPage(id: { eq: $id }) {
      title
      hero: _rawHero(resolveReferences:{ maxDepth: 40})
      heroImage: hero {
        image {
          asset {
            fixed(width: 1000) {
              src
            }
          }
        }
      }
      content: _rawContent(resolveReferences:{ maxDepth: 40})
      seo {
        seo_title
        meta_description
      }
    }
    contact: sanityContact {
      hours
    }
    shopLink: sanityMenu {
       url: servicesLink 
    }
    alertBar: sanityAlertBar {
      enabled
      url
      link {
        slug {
          current
        }
      }
      linkText
      text
    }
  }
`

export default PageTemplate
